import { Fragment } from 'react';
import { Grid } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister } from 'routes/Main/type';

import RowContainer from './RowContainer';
import SectionTitle from './SectionTitle';

interface Props extends IFormRegister {
  disabled?: boolean;
  title: string;
  registerId: string;
  required?: boolean;
  preventCopyPaste?: boolean;
}

const TextAreaSection = (props: Props) => {
  const { required, title, registerId, disabled, register, preventCopyPaste } =
    props;

  const handlePreventEvent = (
    e: React.ClipboardEvent | React.MouseEvent | React.KeyboardEvent
  ) => {
    if (preventCopyPaste) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <Fragment>
      <SectionTitle title={title} />

      <RowContainer xs={12}>
        <Grid item flex={1}>
          <Form.MuiTextField
            multiline
            minRows={5}
            disabled={disabled}
            {...register(registerId)}
            required={required === undefined ? true : required}
            onPaste={preventCopyPaste ? handlePreventEvent : undefined}
            onContextMenu={preventCopyPaste ? handlePreventEvent : undefined}
            onKeyDown={e => {
              if (
                preventCopyPaste &&
                (e.ctrlKey || e.metaKey) &&
                e.key === 'v'
              ) {
                handlePreventEvent(e);
              }
            }}
          />
        </Grid>
      </RowContainer>
    </Fragment>
  );
};

export default TextAreaSection;
